import { render } from "./UserEditInfoPage.vue?vue&type=template&id=0e9791a6"
import script from "./UserEditInfoPage.vue?vue&type=script&lang=js"
export * from "./UserEditInfoPage.vue?vue&type=script&lang=js"

import "./UserEditInfoPage.vue?vue&type=style&index=0&id=0e9791a6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__